import { render, staticRenderFns } from "./固定資産カラムSelect.vue?vue&type=template&id=a608ad8c&"
import script from "./固定資産カラムSelect.ts?vue&type=script&lang=ts&"
export * from "./固定資産カラムSelect.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports